export const ADD_KEYS:Record<string,string>={
    ONE: 'partner_id',
    TWO: 'insurer_id',
    THREE: 'vehicle_category_id',
    FOUR: 'vehicle_type_id',
    FIVE: 'vehicle_usage_id',
    SIX: 'vehicle_condition_id',
    SEVEN: 'max_tenure',
    EIGHT: 'depreciation_rate_year_1',
    NINE: 'depreciation_rate_year_2',
    TEN: 'depreciation_rate_year_3',
    ELEVEN: 'depreciation_rate_year_4',
    TWELVE: 'depreciation_rate_year_5',
}

 
type KEYS = typeof ADD_KEYS[keyof typeof ADD_KEYS];
export type ADD_ROW = {
  [K in KEYS]: string;
};

export type OPTION_TYPE = {
  value: number;
  label: string;
};

export const INITIAL_ROWS: ADD_ROW[] = [
  {
    [ADD_KEYS.ONE]:"",
    [ADD_KEYS.TWO]: "",
    [ADD_KEYS.THREE]: "",
    [ADD_KEYS.FOUR]: "",
    [ADD_KEYS.FIVE]: "",
    [ADD_KEYS.SIX]:"",
    [ADD_KEYS.SEVEN]:"",
    [ADD_KEYS.EIGHT]:"",
    [ADD_KEYS.NINE]:"",
    [ADD_KEYS.TEN]:"",
    [ADD_KEYS.ELEVEN]:"",
    [ADD_KEYS.TWELVE]:"",
  },
  {
    [ADD_KEYS.ONE]:"",
    [ADD_KEYS.TWO]: "",
    [ADD_KEYS.THREE]: "",
    [ADD_KEYS.FOUR]: "",
    [ADD_KEYS.FIVE]: "",
    [ADD_KEYS.SIX]:"",
    [ADD_KEYS.SEVEN]:"",
    [ADD_KEYS.EIGHT]:"",
    [ADD_KEYS.NINE]:"",
    [ADD_KEYS.TEN]:"",
    [ADD_KEYS.ELEVEN]:"",
    [ADD_KEYS.TWELVE]:"",
  },
];


export const INITIAL_LIST = {
  data: INITIAL_ROWS,
  pagination: {
    total: "18",
    limit: 10,
    pages: 2,
    cur_page: 1,
    prev_page: false,
    next_page: true,
  },
};


export const headersData = (translations: any) => {
  return {
    ONE: translations?.MULTI_TENURE?.PARTNER,
    TWO: translations?.MULTI_TENURE?.INSURER,
    THREE: translations?.MULTI_TENURE?.VEHICLE_CATEGORY,
    FOUR: translations?.MULTI_TENURE?.VEHICLE_TYPE,
    FIVE: translations?.MULTI_TENURE?.VEHICLE_USAGE,
    SIX: translations?.MULTI_TENURE?.VEHICLE_CONDITION,
    SEVEN: translations?.MULTI_TENURE?.MAX_TENURE,
    EIGHT: translations?.MULTI_TENURE?.DEPRECIATION_YEAR_1,
    NINE: translations?.MULTI_TENURE?.DEPRECIATION_YEAR_2,
    TEN: translations?.MULTI_TENURE?.DEPRECIATION_YEAR_3,
    ELEVEN: translations?.MULTI_TENURE?.DEPRECIATION_YEAR_4,
    TWELVE: translations?.MULTI_TENURE?.DEPRECIATION_YEAR_5,
  };
};
export const DROPDOWN_KEYS: string[] = [
  ADD_KEYS.ONE,
  ADD_KEYS.SEVEN
];

export const MULTI_DROPDOWN_KEYS: string[] = [
  ADD_KEYS.TWO,
  ADD_KEYS.THREE,
  ADD_KEYS.FOUR,
  ADD_KEYS.FIVE,
  ADD_KEYS.SIX,
];

export const REQUIRED_KEYS: string[] = [
  ADD_KEYS.ONE,
  ADD_KEYS.TWO,
  ADD_KEYS.THREE,
  ADD_KEYS.FOUR,
  ADD_KEYS.FIVE,
  ADD_KEYS.SIX,
  ADD_KEYS.SEVEN
];
export const NUMBER_KEYS: string[] = [
  ADD_KEYS.EIGHT,
  ADD_KEYS.NINE,
  ADD_KEYS.TEN,
  ADD_KEYS.ELEVEN,
  ADD_KEYS.TWELVE
];
export const DECIMAL_KEYS: string[] = [
  ADD_KEYS.EIGHT,
  ADD_KEYS.NINE,
  ADD_KEYS.TEN,
  ADD_KEYS.ELEVEN,
  ADD_KEYS.TWELVE
];
